/**
 * Lazy access to the app logger for the offline services.
 *
 * '../logging' is required on first use rather than imported, because
 * importing it at module load initialises Firebase. Kept in its own module so
 * tests can mock it (vi.mock does not intercept an inline require).
 */
type LogMethod = (message: string, ...args: unknown[]) => void

export type LazyLogger = {
    info: LogMethod
    warn: LogMethod
    error: LogMethod
    debug: LogMethod
}

export const loadLogger = (): LazyLogger => require('../logging').logger
